import React from 'react'
import Seo from './common/Seo';
import Hero from './cases/Hero';
import CaseStudies from './cases/CaseStudies';
import ClosingCTA from './cases/ClosingCTA';

const Cases = () => {
    return (
        <>
            <Seo
              title="도입 사례"
              description="MTST의 MES·AI 솔루션을 도입한 제조기업들의 실제 성과와 데이터 기반 품질·생산성 개선 사례를 확인하세요."
              path="/cases"
            />
            <Hero/>
            <CaseStudies/>
            <ClosingCTA/>
        </>
    );
}

export default Cases
